<script>
	import { Button } from "sveltestrap";
	import Strapi from "strapi-sdk-javascript";
	import { strapi_api } from "../utils/config";
	const strapi = new Strapi(strapi_api);

	export let header;
	export let form;
	export let bookname;

	async function logOutUser() {
		localStorage.clear();
		await strapi.clearToken(localStorage.jwt);
		window.location.href = "/";
	}
</script>

<main
	class="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3"
>
	<div class="main-header main-navbar__search w-100" style="">
		<div class="input-group-seamless ml-3">
			<Button on:click={logOutUser} class="btn-primary btn-logout"
				>Logout</Button
			>
			<span class="username text-capitalize"
				>{localStorage.getItem("username")} ({localStorage.getItem(
					"roleType"
				)})</span
			>
		</div>
	</div>
	<div class="main-content-container container-fluid">
		<!-- Page Header -->
		<div class="page-header row no-gutters py-4">
			<div class="col-12 col-sm-4 text-center text-sm-left mb-0">
				{#if form}
					<h3 class="form-title">{"FORM " + form}</h3>
					<h4 class="book-title">{bookname}</h4>
				{:else}
					<h4 class="page-title">{header}</h4>
				{/if}
			</div>
		</div>
		<!-- End Page Header -->
		<slot />
	</div>
</main>

<style>
	.main-header {
		width: 100%;
		background: #fff;
		height: 64px;
		border-bottom: 1px solid #dadddf;
	}

	.main-content-container {
		padding-left: 96px;
		padding-right: 96px;
	}

	.form-title {
		font-family: 'open_sauce_sanslight';
		font-size: 15.8px;
		font-weight: 300;
		font-stretch: normal;
		font-style: normal;
		line-height: normal;
		letter-spacing: 1px;
		color: #202428;
	}
	.book-title {
		font-family: "open_sauce_tworegular";
		font-size: 28px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.14;
		letter-spacing: -0.4px;
		color: #272828;
	}
</style>
